/**
 * @fileoverview gRPC-Web generated client stub for witbooking.backoffice.insurance.v1
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../../../../validate/validate_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var witbooking_backoffice_common_common_pb = require('../../../../witbooking/backoffice/common/common_pb.js')
const proto = {};
proto.witbooking = {};
proto.witbooking.backoffice = {};
proto.witbooking.backoffice.insurance = {};
proto.witbooking.backoffice.insurance.v1 = require('./insurance_api_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.insurance.v1.InsuranceAPIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.insurance.v1.InsuranceAPIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.insurance.v1.GetInsuranceRequest,
 *   !proto.witbooking.backoffice.insurance.v1.GetInsuranceResponse>}
 */
const methodDescriptor_InsuranceAPI_GetInsurance = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.insurance.v1.InsuranceAPI/GetInsurance',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.insurance.v1.GetInsuranceRequest,
  proto.witbooking.backoffice.insurance.v1.GetInsuranceResponse,
  /**
   * @param {!proto.witbooking.backoffice.insurance.v1.GetInsuranceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.insurance.v1.GetInsuranceResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.insurance.v1.GetInsuranceRequest,
 *   !proto.witbooking.backoffice.insurance.v1.GetInsuranceResponse>}
 */
const methodInfo_InsuranceAPI_GetInsurance = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.insurance.v1.GetInsuranceResponse,
  /**
   * @param {!proto.witbooking.backoffice.insurance.v1.GetInsuranceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.insurance.v1.GetInsuranceResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.insurance.v1.GetInsuranceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.insurance.v1.GetInsuranceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.insurance.v1.GetInsuranceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.insurance.v1.InsuranceAPIClient.prototype.getInsurance =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.insurance.v1.InsuranceAPI/GetInsurance',
      request,
      metadata || {},
      methodDescriptor_InsuranceAPI_GetInsurance,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.insurance.v1.GetInsuranceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.insurance.v1.GetInsuranceResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.insurance.v1.InsuranceAPIPromiseClient.prototype.getInsurance =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.insurance.v1.InsuranceAPI/GetInsurance',
      request,
      metadata || {},
      methodDescriptor_InsuranceAPI_GetInsurance);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.insurance.v1.CreateInsuranceRequest,
 *   !proto.witbooking.backoffice.insurance.v1.CreateInsuranceResponse>}
 */
const methodDescriptor_InsuranceAPI_CreateInsurance = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.insurance.v1.InsuranceAPI/CreateInsurance',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.insurance.v1.CreateInsuranceRequest,
  proto.witbooking.backoffice.insurance.v1.CreateInsuranceResponse,
  /**
   * @param {!proto.witbooking.backoffice.insurance.v1.CreateInsuranceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.insurance.v1.CreateInsuranceResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.insurance.v1.CreateInsuranceRequest,
 *   !proto.witbooking.backoffice.insurance.v1.CreateInsuranceResponse>}
 */
const methodInfo_InsuranceAPI_CreateInsurance = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.insurance.v1.CreateInsuranceResponse,
  /**
   * @param {!proto.witbooking.backoffice.insurance.v1.CreateInsuranceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.insurance.v1.CreateInsuranceResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.insurance.v1.CreateInsuranceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.insurance.v1.CreateInsuranceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.insurance.v1.CreateInsuranceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.insurance.v1.InsuranceAPIClient.prototype.createInsurance =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.insurance.v1.InsuranceAPI/CreateInsurance',
      request,
      metadata || {},
      methodDescriptor_InsuranceAPI_CreateInsurance,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.insurance.v1.CreateInsuranceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.insurance.v1.CreateInsuranceResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.insurance.v1.InsuranceAPIPromiseClient.prototype.createInsurance =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.insurance.v1.InsuranceAPI/CreateInsurance',
      request,
      metadata || {},
      methodDescriptor_InsuranceAPI_CreateInsurance);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.insurance.v1.UpdateInsuranceRequest,
 *   !proto.witbooking.backoffice.insurance.v1.UpdateInsuranceResponse>}
 */
const methodDescriptor_InsuranceAPI_UpdateInsurance = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.insurance.v1.InsuranceAPI/UpdateInsurance',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.insurance.v1.UpdateInsuranceRequest,
  proto.witbooking.backoffice.insurance.v1.UpdateInsuranceResponse,
  /**
   * @param {!proto.witbooking.backoffice.insurance.v1.UpdateInsuranceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.insurance.v1.UpdateInsuranceResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.insurance.v1.UpdateInsuranceRequest,
 *   !proto.witbooking.backoffice.insurance.v1.UpdateInsuranceResponse>}
 */
const methodInfo_InsuranceAPI_UpdateInsurance = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.insurance.v1.UpdateInsuranceResponse,
  /**
   * @param {!proto.witbooking.backoffice.insurance.v1.UpdateInsuranceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.insurance.v1.UpdateInsuranceResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.insurance.v1.UpdateInsuranceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.insurance.v1.UpdateInsuranceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.insurance.v1.UpdateInsuranceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.insurance.v1.InsuranceAPIClient.prototype.updateInsurance =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.insurance.v1.InsuranceAPI/UpdateInsurance',
      request,
      metadata || {},
      methodDescriptor_InsuranceAPI_UpdateInsurance,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.insurance.v1.UpdateInsuranceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.insurance.v1.UpdateInsuranceResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.insurance.v1.InsuranceAPIPromiseClient.prototype.updateInsurance =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.insurance.v1.InsuranceAPI/UpdateInsurance',
      request,
      metadata || {},
      methodDescriptor_InsuranceAPI_UpdateInsurance);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.insurance.v1.GetAllInsurancesRequest,
 *   !proto.witbooking.backoffice.insurance.v1.GetAllInsurancesResponse>}
 */
const methodDescriptor_InsuranceAPI_GetAllInsurances = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.insurance.v1.InsuranceAPI/GetAllInsurances',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.insurance.v1.GetAllInsurancesRequest,
  proto.witbooking.backoffice.insurance.v1.GetAllInsurancesResponse,
  /**
   * @param {!proto.witbooking.backoffice.insurance.v1.GetAllInsurancesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.insurance.v1.GetAllInsurancesResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.insurance.v1.GetAllInsurancesRequest,
 *   !proto.witbooking.backoffice.insurance.v1.GetAllInsurancesResponse>}
 */
const methodInfo_InsuranceAPI_GetAllInsurances = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.insurance.v1.GetAllInsurancesResponse,
  /**
   * @param {!proto.witbooking.backoffice.insurance.v1.GetAllInsurancesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.insurance.v1.GetAllInsurancesResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.insurance.v1.GetAllInsurancesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.insurance.v1.GetAllInsurancesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.insurance.v1.GetAllInsurancesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.insurance.v1.InsuranceAPIClient.prototype.getAllInsurances =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.insurance.v1.InsuranceAPI/GetAllInsurances',
      request,
      metadata || {},
      methodDescriptor_InsuranceAPI_GetAllInsurances,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.insurance.v1.GetAllInsurancesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.insurance.v1.GetAllInsurancesResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.insurance.v1.InsuranceAPIPromiseClient.prototype.getAllInsurances =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.insurance.v1.InsuranceAPI/GetAllInsurances',
      request,
      metadata || {},
      methodDescriptor_InsuranceAPI_GetAllInsurances);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.insurance.v1.DeleteInsuranceRequest,
 *   !proto.witbooking.backoffice.insurance.v1.DeleteInsuranceResponse>}
 */
const methodDescriptor_InsuranceAPI_DeleteInsurance = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.insurance.v1.InsuranceAPI/DeleteInsurance',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.insurance.v1.DeleteInsuranceRequest,
  proto.witbooking.backoffice.insurance.v1.DeleteInsuranceResponse,
  /**
   * @param {!proto.witbooking.backoffice.insurance.v1.DeleteInsuranceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.insurance.v1.DeleteInsuranceResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.insurance.v1.DeleteInsuranceRequest,
 *   !proto.witbooking.backoffice.insurance.v1.DeleteInsuranceResponse>}
 */
const methodInfo_InsuranceAPI_DeleteInsurance = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.insurance.v1.DeleteInsuranceResponse,
  /**
   * @param {!proto.witbooking.backoffice.insurance.v1.DeleteInsuranceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.insurance.v1.DeleteInsuranceResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.insurance.v1.DeleteInsuranceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.insurance.v1.DeleteInsuranceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.insurance.v1.DeleteInsuranceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.insurance.v1.InsuranceAPIClient.prototype.deleteInsurance =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.insurance.v1.InsuranceAPI/DeleteInsurance',
      request,
      metadata || {},
      methodDescriptor_InsuranceAPI_DeleteInsurance,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.insurance.v1.DeleteInsuranceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.insurance.v1.DeleteInsuranceResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.insurance.v1.InsuranceAPIPromiseClient.prototype.deleteInsurance =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.insurance.v1.InsuranceAPI/DeleteInsurance',
      request,
      metadata || {},
      methodDescriptor_InsuranceAPI_DeleteInsurance);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.insurance.v1.ReorderInsuranceRequest,
 *   !proto.witbooking.backoffice.insurance.v1.ReorderInsuranceResponse>}
 */
const methodDescriptor_InsuranceAPI_ReorderInsurance = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.insurance.v1.InsuranceAPI/ReorderInsurance',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.insurance.v1.ReorderInsuranceRequest,
  proto.witbooking.backoffice.insurance.v1.ReorderInsuranceResponse,
  /**
   * @param {!proto.witbooking.backoffice.insurance.v1.ReorderInsuranceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.insurance.v1.ReorderInsuranceResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.insurance.v1.ReorderInsuranceRequest,
 *   !proto.witbooking.backoffice.insurance.v1.ReorderInsuranceResponse>}
 */
const methodInfo_InsuranceAPI_ReorderInsurance = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.insurance.v1.ReorderInsuranceResponse,
  /**
   * @param {!proto.witbooking.backoffice.insurance.v1.ReorderInsuranceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.insurance.v1.ReorderInsuranceResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.insurance.v1.ReorderInsuranceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.insurance.v1.ReorderInsuranceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.insurance.v1.ReorderInsuranceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.insurance.v1.InsuranceAPIClient.prototype.reorderInsurance =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.insurance.v1.InsuranceAPI/ReorderInsurance',
      request,
      metadata || {},
      methodDescriptor_InsuranceAPI_ReorderInsurance,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.insurance.v1.ReorderInsuranceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.insurance.v1.ReorderInsuranceResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.insurance.v1.InsuranceAPIPromiseClient.prototype.reorderInsurance =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.insurance.v1.InsuranceAPI/ReorderInsurance',
      request,
      metadata || {},
      methodDescriptor_InsuranceAPI_ReorderInsurance);
};


module.exports = proto.witbooking.backoffice.insurance.v1;

